var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticStyle:{"margin-top":"0","padding-top":"0"},attrs:{"input-value":_vm.currentItem.isActive || _vm.currentItem.status,"color":"primary","dense":"","hide-details":"","inset":""},on:{"change":function($event){return _vm.switchHandler(_vm.currentItem,$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }